// extracted by mini-css-extract-plugin
module.exports = {"root":"CounterpartyDetail_root_1ddgk","loading":"CounterpartyDetail_loading_2LzcE","progress":"CounterpartyDetail_progress_4SF_1"};